import { useEffect } from "react";
import { useLang } from "@/i18n";

const SEO = {
  tr: {
    title: "DMD GROUP INT. | DMD GRUP DIŞ TİCARET — Uluslararası Ticaret & Transit",
    description:
      "DMD GROUP INT. (DMD GRUP DIŞ TİCARET LTD ŞTİ) — 2018'den beri Türkiye merkezli ihracat ve uluslararası transit ticaret. Çin ve Uzak Doğu'dan Türkmenistan ve Özbekistan pazarına hızlı ve ekonomik lojistik.",
  },
  en: {
    title: "DMD GROUP INT. | DMD GRUP DIŞ TİCARET — International Trade & Transit",
    description:
      "DMD GROUP INT. — Turkey-based export and international transit trade since 2018. Sourcing from China and the Far East, serving Turkmenistan and Uzbekistan with fast, affordable logistics.",
  },
  ru: {
    title: "DMD GROUP INT. | DMD GRUP DIŞ TİCARET — Международная торговля и транзит",
    description:
      "DMD GROUP INT. — экспорт и международная транзитная торговля из Турции с 2018 года. Поставки из Китая и Дальнего Востока в Туркменистан и Узбекистан с быстрой и выгодной логистикой.",
  },
};

const KEYWORDS =
  "DMD GROUP, DMD GROUP INT, DMD GRUP, DMD GRUP DIŞ TİCARET, DMD GRUP DIS TICARET, dış ticaret, transit ticaret, Türkiye ihracat, Çin tedarik, Türkmenistan, Özbekistan, Orta Asya, PET granül, Wankai, Angel Yeast, SunVera, lojistik, ithalat, ihracat";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export default function useSEO() {
  const { lang } = useLang();
  useEffect(() => {
    const s = SEO[lang] || SEO.tr;
    document.title = s.title;
    document.documentElement.lang = lang;
    setMeta("name", "description", s.description);
    setMeta("name", "keywords", KEYWORDS);
    setMeta("property", "og:title", s.title);
    setMeta("property", "og:description", s.description);
    setMeta("property", "og:locale", { tr: "tr_TR", en: "en_US", ru: "ru_RU" }[lang]);
    setMeta("name", "twitter:title", s.title);
    setMeta("name", "twitter:description", s.description);
  }, [lang]);
}
